const BASE_URL = "https://krumago-application-assets.s3.us-east-1.amazonaws.com/Krumago+Main+Assets/";
export const KRUMAGO = {
    LANDING_PAGE: {
        IMAGE_1: `${BASE_URL}pic.jpg`,
    },

    CONTACT: {
        IMAGE_1: `${BASE_URL}contact22.jpg`,
    },

    IMAGES: {
        TARGET_3D: `${BASE_URL}3d-target.png`,
        ADMISSION: `${BASE_URL}addmission.jpg`,
        AVPS: `${BASE_URL}AVPS.png.png`,
        BANNER_1: `${BASE_URL}banner1.png`,
        BANNER_2: `${BASE_URL}banner2.png`,
        BANNER_3: `${BASE_URL}banner3.png`,
        BILD: `${BASE_URL}Bild.png`,
        BRIDGING_THE_KNOWLEDGE_GAP: `${BASE_URL}BridgingTheKnowledgeGap.png`,
        BUILDING: `${BASE_URL}building.png`,
        BUSINESS_SUPPORT: `${BASE_URL}Business support-amico.png`,
        BUSINESS_GROWTH: `${BASE_URL}business-growth.png`,
        BUSINESS: `${BASE_URL}business.png`,
        CEO: `${BASE_URL}CEO.png`,
        CHALLENGE: `${BASE_URL}challenge.jpg`,
        CLASSROOM: `${BASE_URL}classroom.png`,
        CLOUD_COMPUTING: `${BASE_URL}cloud-computing.png`,
        CORE_JAVA_BANNER: `${BASE_URL}coreJAVABanner.png`,
        CURRICULUM: `${BASE_URL}curriculum.png`,
        DASHBOARD: `${BASE_URL}dashboard.png`,
        E_LEARNING: `${BASE_URL}e-learning.png`,
        E_LEARNING_ALT: `${BASE_URL}elearning.png`,
        ENROLL_NOW: `${BASE_URL}enrollNow.png`,
        GROOMING: `${BASE_URL}Grooming.png`,
        GUIDANCE: `${BASE_URL}guidance.png`,
        HOW_IT_WORKS: `${BASE_URL}howItWork.jpg`,
        HTTP: `${BASE_URL}http.png`,
        INCLUSIVITY: `${BASE_URL}inclusivity.png`,
        INSIGHTS: `${BASE_URL}Insights.png`,
        JAVA_BANNER: `${BASE_URL}javaBanner.png`,
        JOIN_US_ABOUT: `${BASE_URL}joinUSAbout.png`,
        KRUMAGO: `${BASE_URL}krumago.png`,
        KRUMAGO_3: `${BASE_URL}Krumago3.png`,
        KRUMAGO_IMG: `${BASE_URL}Krumagoimg.png`,
        LANDING_PAGE: `${BASE_URL}landingPage.jpg`,
        MANAGEMENT: `${BASE_URL}management.png`,
        ODM_BANNER: `${BASE_URL}OdmBanner.png`,
        PERSONAL_TRAINER: `${BASE_URL}personal-trainer.png`,
        PLANNING: `${BASE_URL}planning.png`,
        REPORT: `${BASE_URL}report.png`,
        SCALABILITY: `${BASE_URL}scalability.png`,
        SCHEDULE_IMG_1: `${BASE_URL}scheduleimg1.png`,
        SUPPLY: `${BASE_URL}supply.png`,
        WEB_ANALYTICS: `${BASE_URL}web-analytics.png`,
        WOMEN_IMG: `${BASE_URL}womenImg.jpg`,
    },
};
